import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Link } from 'react-scroll';
import Typewriter from 'typewriter-effect';
import Button from '@mui/material/Button';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SpeedDialComponent from './components/SpeedDialComponent';
import './style.scss';
import MyPicture from './Untitled-25.png';


function App() {

  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  const buttonTheme = createTheme({
    palette: {
      mode: 'light',
    },
  });

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header darkMode={darkMode} onToggleDarkMode={toggleDarkMode} />
        <div className='body'>
          <div className='container'>
            <div className='hero-section'>
              <>
                <div className='wiggle-shape'></div>
                <div className='wiggle-shape'></div>
                <div className='wiggle-shape'></div>
              </>
              <div className='left-section'>
                <h1>
                  Hi, My name is <br />Sahib Sidhu. I am a
                </h1>
                <div className='typewriter'>
                  <Typewriter
                    onInit={(typewriter) => {
                      typewriter
                        .typeString('Full Stack Developer.')
                        .pauseFor(1800)
                        .deleteAll()
                        .typeString('Designer.')
                        .pauseFor(1800)
                        .deleteAll()
                        .typeString('Gamer.')
                        .pauseFor(1800)
                        .start();
                    }}
                    options={{
                      loop: true,
                    }}
                  />
                </div>
                <div className={`main-btn`}>
                  <Link to="projects" offset={-100} smooth={true} duration={500}>
                    <ThemeProvider theme={buttonTheme}>
                      <Button variant='contained' size='large' className={`customButton`}>
                        View my Work
                      </Button>
                    </ThemeProvider>
                  </Link>
                  <Link to="contact" smooth={true} duration={500}>
                    <ThemeProvider theme={buttonTheme}>
                      <Button variant='outlined' size='large' className={`customButton`}>
                        Let's Talk
                      </Button>
                    </ThemeProvider>
                  </Link>
                </div>
              </div>
              <div className='right-section'>
                <img src={MyPicture} alt='My Portrait' />
              </div>
            </div>
            <About />
            <Projects />
            <Skills />
            <Contact />
          </div>
        </div>
      </ThemeProvider>
        <SpeedDialComponent />
        <Footer darkMode={darkMode} />
    </Router>
  );
}

export default App;